import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import { isMobileLarge } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import { memo, useEffect, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { getHouseAd } from '../../../components/HouseAd/queries';
import { RESIZE } from '../../../config/constants';
import { useQuery } from 'urql';
import css from './Five.module.scss';
import newLineToBreakTag from '../../../utils/strings/newLineToBreakTag';
import UGC from '../../../components/UGC';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Big = function Big(_ref) {
  var image = _ref.image,
      blockId = _ref.blockId;

  var _useQuery = useQuery({
    query: getHouseAd,
    variables: {
      blockId: blockId
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  return /*#__PURE__*/_jsx("div", {
    className: cc([css.link, css.big]),
    style: {
      aspectRatio: "".concat(image.width, " / ").concat(image.height)
    },
    children: /*#__PURE__*/_jsx(UGC, {
      image: image,
      instagramProducts: fetching ? {
        edges: []
      } : data.blockProducts
    })
  });
};

Big.propTypes = {
  image: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number
  }),
  blockId: PropTypes.string
};
var classes = [css.tl, css.tr, css.bl, css.br];
var MOBILE = 'mobile';
var DESKTOP = 'desktop';
export var Five = /*#__PURE__*/memo(function (_ref2) {
  var _firstBlock$node;

  var blocks = _ref2.blocks;

  var _useState = useState(isMobileLarge() ? MOBILE : DESKTOP),
      _useState2 = _slicedToArray(_useState, 2),
      type = _useState2[0],
      setType = _useState2[1];

  useEffect(function () {
    var onResize = function onResize() {
      /* eslint-disable */
      var newType = isMobileLarge() ? MOBILE : DESKTOP;
      /* eslint-enable */

      if (newType === type) {
        return;
      }

      setType(newType);
    };

    window.addEventListener(RESIZE, onResize);
    return function () {
      window.removeEventListener(RESIZE, onResize);
    };
  }, [type]);
  var firstBlock = blocks.edges[0];
  var layout = firstBlock === null || firstBlock === void 0 ? void 0 : (_firstBlock$node = firstBlock.node) === null || _firstBlock$node === void 0 ? void 0 : _firstBlock$node.layout;
  var isMobile = type === MOBILE;
  var block = firstBlock; // If it's 5 just use the first block. If it's 6 use the 1st or 2nd (2nd is mobile)

  if (blocks.edges.length === 6) {
    block = isMobile ? blocks.edges[1] : firstBlock;
  }

  var lastBlocks = blocks.edges.slice(-4);
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, _defineProperty({}, css.right, layout === 'RIGHT')]),
    children: [/*#__PURE__*/_jsx(Big, {
      image: block.node.image,
      blockId: block.node.id
    }), lastBlocks.map(function (_ref4, idx) {
      var _ref4$node = _ref4.node,
          id = _ref4$node.id,
          image = _ref4$node.image,
          imageMobile = _ref4$node.imageMobile,
          url = _ref4$node.url,
          title = _ref4$node.title,
          titleColor = _ref4$node.titleColor;
      var img = isMobile && imageMobile ? imageMobile : image;
      return /*#__PURE__*/_jsxs("a", {
        className: cc([css.link, classes[idx]]),
        href: url,
        children: [/*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, img), {}, {
          sizes: [160, 300],
          wrap: false
        })), title && /*#__PURE__*/_jsx("h2", {
          className: css.title,
          dangerouslySetInnerHTML: {
            __html: newLineToBreakTag(title)
          },
          style: {
            color: titleColor
          }
        })]
      }, id);
    })]
  });
});
Five.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      node: PropTypes.shape({
        layout: PropTypes.string
      })
    }))
  })
};